export const DASHBOARD_COMPONENT_CONFIG_JS_CODE = `const componentConfig = {
    "originId": "%originId%",
    "dashboardId": "%dashboardId%",
    "interactivityProfileName":"%ip%",%ipOverrides%
    "theme":"%themeComposer%",
    "editor": { "placement": "%editorPlacement%" },
    "header": { 
        "showActions": %showActions%,
        "showTitle": %showTitle%,
        "visible": %showHeader%
    }
}`;

export const DOUBLE_DASHBOARDS_FIRST_DASHBOARD_CONFIG_JS_CODE = `const componentConfig = {
    "originId": "%originId%",
    "dashboardId": "%dashboardId%",
    "interactivityProfileName":"%ip%",%ipOverrides%
    "theme":"%themeComposer%",
    "editor": { "placement": "%editorPlacement%" },
    "header": { 
        "showActions": %showActions%,
        "showTitle": %showTitle%,
        "visible": %showHeader%
    }
}

const componentConfig2 = {
    "originId": "%originId%",
    "dashboardId": "%dashboardId2%",
    "interactivityProfileName":"%ip%",%ipOverrides%
    "theme":"%themeComposer%",
    "editor": { "placement": "%editorPlacement%" },
    "header": {
        "showActions": %showActions%,
        "showTitle": %showTitle%,
        "visible": %showHeader%
    }
}

function createWrapper(parentContainer) {
    const widgetWrapper = document.createElement("div");
    widgetWrapper.classList.add("widget-wrapper");
    parentContainer.append(widgetWrapper);

    return widgetWrapper;
}

async function mountDashboard(embedManager, containerSelector, config) {
    const parentContainer = document.querySelector(containerSelector);
    if (!parentContainer) {
        throw new Error(\`Container not found: \${containerSelector}\`);
    }

    const widgetWrapper = createWrapper(parentContainer);
    const component = await embedManager.createComponent("dashboard", config);
    await component.render(widgetWrapper, {
        width: "100%",
        height: "100%",
    });

    return component;
}
// Supported CSS classes : '.top-left-container','.top-right-container',
// '.bottom-left-container','.bottom-right-container',
// '.scroll-right-container','.scroll-left-container'
embedManagerPromise.then(async (embedManager) => {
    await mountDashboard(embedManager, ".top-left-container", componentConfig);
    await mountDashboard(embedManager, ".bottom-left-container", componentConfig2);
});`;

export const DOUBLE_DASHBOARDS_LAYOUT_HTML_CODE = `
    <div class="top-left-container"></div>
    <div class="bottom-left-container"></div>`;

export const DOUBLE_DASHBOARDS_CSS_CODE = `
html,
body {
    height: 100%;
}

body {
    margin: 0;
    font-family: "Open Sans", sans-serif;
}

.top-left-container,
.bottom-left-container {
    overflow: auto;
    flex-basis: 100%;
    position: relative;
}

.widget-wrapper {
    height: 100%;
    position: relative;
}`;
